export default __webpack_public_path__ + "static/media/app-ads.7997748b.txt";